import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import moment from 'moment'
import renderTextAreaInputWithFeedback from '../../../../components/ui/forms/renderTextAreaInputWithFeedback'
import renderTypableDatePickerInput from '../../../../components/ui/forms/renderTypableDatePickerInput'
import renderTableInput from '../../../../components/ui/forms/renderTableInput'
import formValidators from '../../../../utils/validation/formValidators'

/**
 * @class AdminAssignTaskToStudentsForm
 * @description Form to assign a Task to a Student
 */
class AdminAssignTaskToStudentsForm extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    change: PropTypes.func.isRequired,
    formValues: PropTypes.any.isRequired,
    initialValues: PropTypes.any.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    listData: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)
    this.tableJson =  this.props.isMobile ?
      [
        { value: 'fullName', displayName: 'Name' },
      ]:
      [
        { value: 'fullName', displayName: 'Name' },
        { value: 'info.classGrade', displayName: 'Class Year' },
        { value: 'email', displayName: 'Email' },
      ]
  }

  /**
   * @method componentWillReceiveProps
   * @description When a new activeTask is selected, this sets the pre-selected users on the form
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    const currentFormValues = this.props.formValues
    const nextFormValues = nextProps.formValues
    if (currentFormValues.assignedTo !== nextFormValues.assignedTo) {
      this.props.change('assignedTo', nextFormValues.assignedTo)
      this.props.change('dueDate', nextFormValues.dueDate)
    }
    if (currentFormValues.description !== nextFormValues.description) {
      this.props.change('description', nextFormValues.description)
    }
  }

  /**
   * @method render
   */
  render() {
    const { invalid, isFetching, onSubmit, pristine, listData } = this.props

    return (
      <div>
        <Field
          name="dueDate"
          minDate={moment()
            .add(1, 'days')
            .toISOString()}
          label="Due Date (when do students have to complete the task by?)"
          component={renderTypableDatePickerInput}
        />
        <div style={{ marginTop: 20 }} />
        <Field
          name="description"
          label="Tell the students what to do"
          maxLength={200}
          component={renderTextAreaInputWithFeedback}
        />
        <div style={{ marginTop: 30 }} />
        <Field
          label="Students to Assign"
          name="assignedTo"
          component={renderTableInput}
          colNames={this.tableJson}
          data={listData}
        />
        <button
          className="btn btn-lg btn-success mb-4"
          onClick={onSubmit}
          disabled={invalid || pristine || isFetching}
        >
          {isFetching ? 'Creating...' : 'Assign'}
        </button>
      </div>
    )
  }
}

/**
 * @const validate
 * @param values
 * @returns {{}}
 */
const validate = values => {
  const errors = {}

  if (!values.dueDate) {
    errors.dueDate = 'Required'
  }

  errors.dueDate = formValidators.isAfter(values.dueDate, moment())

  return errors
}

/**
 * @const withReduxForm
 * @description Creates a redux-connected version of the form
 */
const withReduxForm = reduxForm({
  form: 'adminAssignTaskToStudentsForm',
  validate,
})(AdminAssignTaskToStudentsForm)

export default withReduxForm



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/components/AdminAssignTaskToStudentsForm.js